// src/components/TrustBadgesSection.tsx

import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import badge1 from '../assets/Bedges/verifiedlogo.png';
import badge2 from '../assets/Bedges/verifiedlogo1.png';

const badges = [
  { src: badge1, altKey: 'badge_coc_certified_alt' },
  { src: badge2, altKey: 'badge_verified_by_coc_alt' },
];

const TrustBadgesSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    // Removed mt-72. The py-20 will provide vertical spacing.
    <section className=" py-20 px-4 md:px-8 lg:px-20 text-center relative">
      <div className="max-w-6xl mx-auto">
         <p className="text-gray-700 text-6xl font-semibold mb-12">
          {t('trust_badges_heading_top')}
        </p>

        <h2 className="text-gray-900 text-4xl md:text-5xl font-extrabold leading-tight mb-6">
          {t('trust_badges_heading_main')}
        </h2>
        <p className="text-gray-600 text-lg max-w-3xl mx-auto mb-8">
          {t('trust_badges_description')}
        </p>

       <div className="flex flex-wrap justify-center items-center gap-10">
          {badges.map((badge, index) => (
            <motion.img
              key={index}
              src={badge.src}
              alt={t(badge.altKey)}
              className="h-28 md:h-36 object-contain"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15, duration: 0.6 }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadgesSection;